module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.show) ? _c('div', {
    staticClass: ["container"]
  }, [_c('div', {
    staticClass: ["mask"],
    style: {
      height: _vm.maskHeight + 'px'
    },
    on: {
      "click": _vm.onCancled
    }
  }), _c('div', {
    staticClass: ["operate-box"],
    style: {
      top: _vm.boxMarginTop + 'px'
    }
  }, [_c('div', {
    staticClass: ["box-title-wrapper"]
  }, [_c('text', {
    staticClass: ["box-title-text"]
  }, [_vm._v(_vm._s(_vm.title))])]), _c('div', {
    staticClass: ["box-input-wrapper"]
  }, [_c('input', {
    staticClass: ["box-input"],
    attrs: {
      "value": _vm.inputName,
      "type": "text",
      "placeholder": _vm.placeholder
    },
    on: {
      "input": _vm.onInput
    }
  })]), _c('div', {
    staticClass: ["box-btn-group"]
  }, [_c('div', {
    staticClass: ["box-btn-wrapper", "btn-border-r"],
    on: {
      "click": _vm.onCancled
    }
  }, [_c('text', {
    staticClass: ["box-btn-text", "cancel-text"],
    style: {
      color: _vm.cancelColor
    }
  }, [_vm._v("取消")])]), _c('div', {
    staticClass: ["box-btn-wrapper"],
    on: {
      "click": _vm.onOkClicked
    }
  }, [_c('text', {
    staticClass: ["box-btn-text"],
    style: {
      color: _vm.confirmColor
    }
  }, [_vm._v("确定")])])])])]) : _vm._e()
},staticRenderFns: []}
module.exports.render._withStripped = true


//////////////////
// WEBPACK FOOTER
// ./~/weex-vue-loader/lib/template-compiler.js?id=data-v-30dfad71!./~/weex-vue-loader/lib/selector.js?type=template&index=0!./packages/dof-promt/index.vue
// module id = 589
// module chunks = 0 1